import { Component } from 'react';
import Input from './input';
import Select from './select';
import ToggleSwitch from './toggleSwitch';
import Joi from 'joi-browser';
import TextArea from './textArea';

class Form extends Component {
  state = { data: {}, genres: [], errors: {} };

  validate = () => {
    const options = { abortEarly: false };
    const result = Joi.validate(this.state.data, this.schema, options);
    //break if no error
    if (!result.error) return null;
    const errors = {};
    for (const item of result.error.details) {
      errors[item.path[0]] = item.message;
    }
    return errors;
  };

  validateProperty = ({ name, value }) => {
    //for key use []. else it will rename. known as computed property
    const obj = { [name]: value };
    const schema = { [name]: this.schema[name] };
    const result = Joi.validate(obj, schema);
    if (
      (name === 'username' || name === 'email') &&
      value.length !== 0 &&
      !value.includes('@accenture.com')
    ) {
      return 'Email is not valid. Only Accenture emails are supported';
    }
    if (name.toLowerCase().includes('password') && result.error) {
      return 'Password should atleast be 8 characters with minimum 1 uppercase, 1 lowercase, 1 special character and 1 number';
    }
    return result.error ? result.error.details[0].message : null;
  };

  handleSubmit = (e) => {
    //prevents bundle.js refresh multiple times
    e.preventDefault();
    const errors = this.validate();
    this.setState({ errors: errors || {} });
    if (errors) return;
    this.doSubmit();
  };

  handleChange = ({ currentTarget: input }) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(input);
    if (errorMessage) errors[input.name] = errorMessage;
    else delete errors[input.name];

    const data = { ...this.state.data };
    data[input.name] = input.value;
    this.setState({ data, errors });
  };

  renderTextBox(name, label, placeholder, customclass) {
    const { data, errors } = this.state;
    return (
      <TextArea
        name={name}
        label={label}
        placeholder={placeholder}
        customclass={customclass}
        value={data[name] || ''}
        error={errors[name] || ''}
        handleChange={this.handleChange}
      />
    );
  }

  renderInput(
    name,
    label,
    placeholder,
    type = 'text',
    icon = '',
    disabled = false
  ) {
    const { data, errors } = this.state;
    return (
      <Input
        name={name}
        type={type}
        label={label}
        placeholder={placeholder}
        value={data[name] || ''}
        error={errors[name] || ''}
        handleChange={this.handleChange}
        icon={icon}
        disabled={disabled}
      />
    );
  }

  renderSelect(name, label, options) {
    const { data, errors } = this.state;
    return (
      <Select
        name={name}
        label={label}
        options={options}
        value={data[name] || ''}
        error={errors[name] || ''}
        handleChange={this.handleChange}
      />
    );
  }

  renderButton(label, disabled, width, margin) {
    return (
      <button
        disabled={this.validate() || disabled ? true : false}
        className='btn btn-primary'
        style={{ width, margin }}
      >
        {label}
      </button>
    );
  }

  renderToggle(id, checked, onchange, disabled) {
    return (
      <ToggleSwitch
        id={id}
        small
        checked={checked}
        onChange={onchange}
        disabled={disabled}
      />
    );
  }
}

export default Form;
